import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import countriesAndTimezones from 'countries-and-timezones';
import { UsaStates } from 'usa-states';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Button from 'components/common/Button';
import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import CheckboxField from 'components/fields/CheckboxField';
import AutosuggestField from 'components/fields/AutosuggestField';
import FormError from 'components/common/FormError';
import UploadField from 'components/fields/UploadField';
import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';

import { createBusiness, updateBusiness } from 'redux/modules/business';
import { updateFacility } from 'redux/modules/facilities';
import { requestFetchPlacesAutocomplete } from 'redux/modules/placesAutocomplete';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';
import imageFileTypes from 'config/imageFileTypes';

const usaStates = new UsaStates();
const usaTimeZones = countriesAndTimezones.getTimezonesForCountry('US')
  .map(item => item.name);

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  form: {
    margin: '10px 40px',
    minHeight: 240,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function onSubmit(values, dispatch, props) {
  const diffValues = props.initialValues.ID ? objectDiff(values, props.initialValues) : {};
  return new Promise((resolve, reject) => {
    dispatch(updateBusiness({
      values: {
        'Company Identify': props.initialValues.ID ? {
          ID: props.initialValues.ID,
          ...diffValues,
          ...diffValues['Trading Partner ID'] === '' ? {
            'Trading Partner ID': null,
          } : {},
          ...diffValues.MEDICAID === '' ? {
            MEDICAID: null,
          } : {},
          ...diffValues.MEDICARE === '' ? {
            MEDICARE: null,
          } : {},
          ...diffValues['Primary Taxonomy'] === '' ? {
              'Primary Taxonomy': null,
            } : {},
        } : values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessGeneralCompanyIdentifiersForm = ({ handleSubmit, error, classes }) => (
  <form
    className={classes.form}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classNames(classes.grid, classes.gridGutter)}
      container
      spacing={24}
    >
      <Grid item xs={12}>
        <Typography className={classes.typography} align="center">
          Enter your Contact Info and these will populate on forms such as Delivery Tickets and Letters of Medical Necessity
        </Typography>
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={4}>
        <Field
          id="Practice NPI"
          name="Practice NPI"
          label="Practice NPI *"
          component={TextField}
          validate={[validate.required, validate.minLength10]}
          maxLength="10"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Field
          id="EIN"
          name="EIN"
          label="EIN *"
          component={TextField}
          validate={[validate.required]}
          maxLength="9"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Field
          id="Trading Partner ID"
          name="Trading Partner ID"
          label="Trading Partner ID"
          component={TextField}
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={4}>
        <Field
          id="MEDICARE"
          name="MEDICARE"
          label="MEDICARE"
          component={TextField}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Field
          id="MEDICAID"
          name="MEDICAID"
          label="MEDICAID"
          component={TextField}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Field
          id="Primary Taxonomy"
          name="Primary Taxonomy"
          label="Primary Taxonomy"
          component={TextField}
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

BusinessGeneralCompanyIdentifiersForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessGeneralCompanyIdentifiersForm.defaultProps = {
  error: null,
};

export default reduxForm({
  form: 'companyIdentifiers',
  enableReinitialize: true,
  onSubmit,
})(withStyles(styles)(BusinessGeneralCompanyIdentifiersForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessGeneralDialog/BusinessGeneralCompanyIdentifiersForm.js